import { sanitizeSchema } from "@/lib/schemaSanitize";
import { serializeJsonLd } from "@/lib/jsonLd";

// Renders one or more JSON-LD structured-data blocks for a page. Each schema
// gets its own <script> tag so it can safely sit alongside any
// entity-specific schema (Event/Artist/Venue, BreadcrumbList, ...) a page
// already renders elsewhere — multiple JSON-LD scripts on one page is valid
// and is how CMS-supplied schema gets "appended" rather than overwriting it.
//
// Every block goes through `sanitizeSchema` first: "@context" is a
// protocol-level constant a CMS field can leave blank or wrong, empty-string
// properties are worse than absent ones in Google's eyes, and an Event node
// with no name or startDate is an error rather than a rich-result candidate.
// See lib/schemaSanitize.js.
export default function PageSchema({ schemas, idPrefix = "cms-schema" }) {
  const list = (Array.isArray(schemas) ? schemas : [schemas])
    .flatMap((schema) => (Array.isArray(schema) ? schema : [schema]))
    .map(sanitizeSchema)
    .filter(Boolean);

  if (!list.length) return null;

  return (
    <>
      {list.map((schema, index) => (
        <script
          key={`${idPrefix}-${index}`}
          id={`${idPrefix}-${index}`}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: serializeJsonLd(schema) }}
        />
      ))}
    </>
  );
}
